module.exports = "/images/timeline-icon-dark.svg?01044e87d88f3194ded4b1157385210e";